/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IApplication, IModule, IOrganization } from "../../../models/Roles/RolesContracts";
import { IBuiltInPolicyItem, IPage } from '../../../models/Policies/BuiltInPolicies';
import {
  GET_APPLICATIONS_FOR_ORGANIZATION,
  GET_MODULES_FOR_APPLICATION,
  GET_ORGANIZATIONS_LIST,
  SET_GLOBAL_ROLE_BUILTIN_POLICIES,
  ADD_MODULE,
  SET_BUILTIN_POLICIES_TO_ASSOCIATE,
  CLEAR_BUILTIN_POLICIES_TO_ASSOCIATE
} from './types';

export const getOrganizationsListAction = (organizations: IOrganization[]) => {
  return {
    type: GET_ORGANIZATIONS_LIST,
    organizations: organizations
  };
};

export const getApplicationsForOrganizationAction = (applicationsForOrganization: IApplication[]) => {
  return {
    type: GET_APPLICATIONS_FOR_ORGANIZATION,
    applicationsForOrganization: applicationsForOrganization
  };
};

export const getModulesForApplicationAction = (applicationsForOrganization: IModule[]) => {
  return {
    type: GET_MODULES_FOR_APPLICATION,
    modulesForApplication: applicationsForOrganization
  };
};

export const setGlobalRoleBuiltinPolicies = (builtinPolicies: IBuiltInPolicyItem[], roleId: number) => {
  return {
    type: SET_GLOBAL_ROLE_BUILTIN_POLICIES,
    builtinPolicies,
    roleId
  };
};

export const addModuleAction = (module: IModule) => {
  return {
    type: ADD_MODULE,
    module
  };
};

export const setBuiltinPoliciesToAssociate = (entities: IBuiltInPolicyItem[], page: IPage) => {
  return {
    type: SET_BUILTIN_POLICIES_TO_ASSOCIATE,
    entities,
    page
  };
};

export const clearBuiltinPoliciesToAssociate = () => {
  return {
    type: CLEAR_BUILTIN_POLICIES_TO_ASSOCIATE
  };
};
